import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom"; // AGREGAR ESTA IMPORTACIÓN


// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Autocomplete from "@mui/material/Autocomplete";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Link from "@mui/material/Link"; // AGREGAR ESTA IMPORTACIÓN


// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import MDModal from "components/MDModal";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Custom Pagination component
import Pagination from "components/common/pagination/Pagination";

// Services
import candidateService from "services/candidatoService";
import emailService from "services/emailService";
import licenciaService from "services/licenciaService";

// Context
import { useMaterialUIController, setSearchTerm } from "context";

const ITEMS_PER_PAGE = 5;

function AsignarLicencias() {
  const navigate = useNavigate(); // AGREGAR ESTE HOOK
  const [selectedLicenseType, setSelectedLicenseType] = useState("");
  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [tableData, setTableData] = useState({ columns: [], rows: [] });
  const [controller, dispatch] = useMaterialUIController();
  const { searchTerm } = controller;
  const [loading, setLoading] = useState(false);
  const [allCandidates, setAllCandidates] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [notification, setNotification] = useState({
    open: false,
    message: "",
    color: "success",
  });
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  
  // Estados para manejo de licencias
  const [licencias, setLicencias] = useState({
    licencias_disponibles: 0,
    licencias_compradas: 0,
    licencias_usadas: 0
  });
  const [showLicenseWarning, setShowLicenseWarning] = useState(false);

  // Lista de licencias disponibles
  const availableLicenses = ["Quadrante H"];

  // Configurar columnas de la tabla
  const tableColumns = [
    { Header: "Seleccionar", accessor: "seleccionar", width: "8%" },
    { Header: "Nombre", accessor: "nombre", width: "15%" },
    { Header: "Documento", accessor: "documento", width: "10%" },
    { Header: "Email", accessor: "email", width: "15%" },
    { Header: "Edad", accessor: "edad", width: "8%" },
    { Header: "Género", accessor: "genero", width: "10%" },
    { Header: "Nivel Educativo", accessor: "nivel_educativo", width: "12%" },
    { Header: "Experiencia", accessor: "experiencia_laboral", width: "10%" },
    { Header: "Cargo", accessor: "cargo_aplicado", width: "12%" },
  ];

  useEffect(() => {
    loadCandidates();
    loadLicencias();
    
    // Escuchar actualizaciones de licencias
    const handleLicenciasActualizadas = (event) => {
      setLicencias(event.detail);
    };
    
    window.addEventListener('licenciasActualizadas', handleLicenciasActualizadas);
    
    return () => {
      window.removeEventListener('licenciasActualizadas', handleLicenciasActualizadas);
    };
  }, []);

  // Cargar licencias disponibles
  const loadLicencias = async () => {
    try {
      const licenciasData = await licenciaService.getLicencias();
      setLicencias(licenciasData);
    } catch (error) {
      console.error('Error al cargar licencias:', error);
    }
  };

  // Verificar si hay suficientes licencias cuando cambia la selección
  useEffect(() => {
    if (selectedCandidates.length > 0) {
      const disponibles = licencias.licencias_disponibles || 0;
      setShowLicenseWarning(selectedCandidates.length > disponibles);
    } else {
      setShowLicenseWarning(false);
    }
  }, [selectedCandidates, licencias]);

  const loadCandidates = async () => {
    try {
      setLoading(true);
      const candidates = await candidateService.getAllCandidates();
      const sortedCandidates = candidates.sort((a, b) => {
        const dateA = new Date(a.updated_at);
        const dateB = new Date(b.updated_at);
        return dateB.getTime() - dateA.getTime();
      });
      setAllCandidates(sortedCandidates);
    } catch (error) {
      showNotification(error.message || "Error al cargar candidatos", "error");
    } finally {
      setLoading(false);
    }
  };

  const showNotification = (message, color = "success") => {
    setNotification({
      open: true,
      message,
      color,
    });
  };

  const closeNotification = () => {
    setNotification({
      ...notification,
      open: false,
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleCandidateSelect = (candidateId, isSelected) => {
    setSelectedCandidates(prev => {
      const newSelection = isSelected 
        ? [...prev, candidateId]
        : prev.filter(id => id !== candidateId);
      return newSelection;
    });
  };

  const handleNavigateToComprar = () => {
    navigate('/gestion-licencias/comprar');
  };

  useEffect(() => {
    if (allCandidates.length > 0) {
      const rows = allCandidates.map((candidate) => ({
        seleccionar: (
          <MDBox display="flex" justifyContent="center" alignItems="center">
            <input
              type="checkbox"
              checked={selectedCandidates.includes(candidate.id_candidato)}
              onChange={(e) => handleCandidateSelect(candidate.id_candidato, e.target.checked)}
            />
          </MDBox>
        ),
        nombre: candidate.nombre_completo || "",
        documento: candidate.documento || "",
        email: candidate.email || "",
        edad: candidate.edad || "",
        genero: candidate.genero || "",
        nivel_educativo: candidate.nivel_educativo || "",
        experiencia_laboral: candidate.experiencia_laboral || "",
        cargo_aplicado: candidate.cargo_aplicado || "",
        original: candidate,
      }));

      setTableData({
        columns: tableColumns,
        rows: rows,
      });
    }
  }, [allCandidates, selectedCandidates]);

  const filteredRows = useMemo(() => {
    if (!searchTerm) {
      return tableData.rows;
    }
    const lowercasedSearchTerm = searchTerm.toLowerCase();
    return tableData.rows.filter((row) => {
      const original = row.original || {};
      
      const fieldContains = (field) => {
        return field && typeof field === 'string' && field.toLowerCase().includes(lowercasedSearchTerm);
      };
      
      const matchNombre = fieldContains(original.nombre_completo);
      const matchDocumento = fieldContains(original.documento?.toString());
      const matchEmail = fieldContains(original.email);
      const matchGenero = fieldContains(original.genero);
      const matchNivelEducativo = fieldContains(original.nivel_educativo) || fieldContains(original.nivelEducativo);
      const matchCargoAplicado = fieldContains(original.cargo_aplicado);
      const matchExperiencia = fieldContains(original.experiencia_laboral);
      
      return matchNombre || matchDocumento || matchEmail || matchGenero || 
             matchNivelEducativo || matchCargoAplicado || matchExperiencia;
    });
  }, [tableData.rows, searchTerm]);

  const totalItems = filteredRows.length;
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const paginatedRows = filteredRows.slice(startIndex, endIndex);

  const handleSelectAll = () => {
    const filteredIds = filteredRows.map(row => row.original?.id_candidato).filter(Boolean);
    const allSelected = filteredIds.every(id => selectedCandidates.includes(id));
    
    if (allSelected && selectedCandidates.length > 0) {
      setSelectedCandidates([]);
      showNotification("Candidatos deseleccionados", "info");
    } else {
      setSelectedCandidates(filteredIds);
      showNotification(`${filteredIds.length} candidato(s) seleccionado(s)`, "info");
    }
  };

  // Validar licencias antes de asignar
  const handleAssignLicense = async () => {
    if (selectedCandidates.length === 0) {
      showNotification("Debes seleccionar por lo menos un candidato", "warning");
      return;
    }

    if (!selectedLicenseType) {
      showNotification("Primero debes seleccionar el tipo de licencia", "warning");
      return;
    }

    // Verificar licencias disponibles
    try {
      const verificacion = await licenciaService.verificarLicenciasDisponibles(selectedCandidates.length);
      
      if (!verificacion.disponible) {
        showNotification(
          `No tienes suficientes licencias. Necesitas ${selectedCandidates.length} pero solo tienes ${verificacion.licencias_disponibles} disponibles. Te faltan ${verificacion.faltantes} licencia(s).`,
          "error"
        );
        return;
      }
    } catch (error) {
      showNotification("Error al verificar licencias: " + error.message, "error");
      return;
    }

    if (selectedCandidates.length > 5) {
      setShowConfirmModal(true);
    } else {
      confirmAssignment();
    }
  };

  const confirmAssignment = async () => {
    setShowConfirmModal(false);

    try {
      setLoading(true);
      
      const idsCandidatos = selectedCandidates.map(id => id);
      const idEmpresa = candidateService.getCurrentCompanyId(); 

      if (!idEmpresa) {
        showNotification("No se pudo obtener el ID de la empresa. Por favor, inicia sesión de nuevo.", "error");
        setLoading(false);
        return;
      }

      showNotification("Generando credenciales y enviando emails...", "info");
      
      const licenseLoginUrl = "https://nuevo-frontend-cuadrante-2.pages.dev/authentication/sign-in"; 

      let emailResults = await emailService.sendMassTestAssignment(
        idsCandidatos,
        idEmpresa,
        licenseLoginUrl
      );

      emailResults.success = emailResults.successful_sends || 0;
      emailResults.errors = (emailResults.results || []).filter(r => !r.success).map(err => ({
        candidate: err.nombre_completo || 'Desconocido',
        email: err.email || 'Desconocido',
        error: err.message || 'Error desconocido'
      }));
      emailResults.total_candidates = emailResults.total_candidates || idsCandidatos.length;

      // Descontar licencias solo por los envíos exitosos
      if (emailResults.success > 0) {
        try {
          await licenciaService.descontarLicencias(emailResults.success);
          
          // Recargar licencias para actualizar el contador
          await loadLicencias();
          
        } catch (licenciaError) {
          console.error('Error al descontar licencias:', licenciaError);
          // No mostramos error al usuario ya que los emails sí se enviaron
        }
      }

      if (emailResults.success > 0) {
        let message = `Credenciales y licencia "${selectedLicenseType}" asignada exitosamente a ${emailResults.success} candidato(s)`;
        
        if (emailResults.total_candidates === 1 && emailResults.results && emailResults.results[0]?.success) {
          message = `Credenciales y licencia "${selectedLicenseType}" asignada exitosamente a ${emailResults.results[0].nombre_completo}`; 
        }

        // Agregar info de licencias al mensaje
        const licenciasRestantes = licencias.licencias_disponibles - emailResults.success;
        message += `. Licencias restantes: ${licenciasRestantes}`;

        if (emailResults.errors.length > 0) {
          message += `. ${emailResults.errors.length} email(s) no pudieron enviarse.`;
          console.error('Errores en envío de credenciales/emails:', emailResults.errors);
        }
        
        showNotification(message, emailResults.errors.length > 0 ? "warning" : "success");
        
        if (emailResults.errors.length > 0) {
          setTimeout(() => {
            const errorDetails = emailResults.errors.map(err => 
              `${err.candidate} (${err.email}): ${err.error}`
            ).join('\n');
            showNotification(
              `Errores detallados:\n${errorDetails}`,
              "error"
            );
          }, 3000);
        }
        
      } else {
        const errorMessage = emailResults.errors.length > 0
          ? emailResults.errors[0].error
          : "No se pudo generar credenciales o enviar emails a ningún candidato. Verifica la configuración.";
        showNotification(errorMessage, "error");

        if (emailResults.errors.length > 1) {
          setTimeout(() => {
            const errorDetails = emailResults.errors.map(err =>
              `${err.candidate} (${err.email}): ${err.error}`
            ).join('\n');
            showNotification(
              `Detalles de errores adicionales:\n${errorDetails}`,
              "error"
            );
          }, 3000);
        }
      }

      if (emailResults.success > 0) {
        setSelectedCandidates([]);
        setSelectedLicenseType("");
      }

    } catch (error) {
      console.error('Error al asignar licencia y credenciales:', error);
      showNotification(
        error.message || "Error al generar credenciales y enviar emails de asignación",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          {/* Filtros y Controles */}
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  Asignar Licencias a Candidatos
                </MDTypography>
              </MDBox>
              <MDBox p={3}>
                {/* Alerta de licencias insuficientes - MEJORADA */}
                {showLicenseWarning && (
                  <Alert 
                    severity="error" 
                    sx={{ 
                      mb: 3,
                      '& .MuiAlert-icon': {
                        fontSize: '28px'
                      }
                    }}
                  >
                    <AlertTitle sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>
                      No cuentas con licencias disponibles
                    </AlertTitle>
                    <MDTypography variant="body2" sx={{ mt: 1 }}>
                      Has seleccionado <strong>{selectedCandidates.length}</strong> candidato(s), pero solo tienes{' '}
                      <strong>{licencias.licencias_disponibles || 0}</strong> licencia(s) disponible(s) en este momento.
                    </MDTypography>
                    <MDTypography variant="body2" sx={{ mt: 1.5, fontWeight: 500 }}>
                      📌 Dirígete a {' '}
                      <Link
                        component="button"
                        onClick={handleNavigateToComprar}
                        sx={{
                          fontWeight: 'bold',
                          textDecoration: 'underline',
                          cursor: 'pointer',
                          color: 'inherit',
                          '&:hover': {
                            color: '#d32f2f',
                            textDecoration: 'underline'
                          }
                        }}
                      >
                        Comprar licencias
                      </Link>
                      {' '}para adquirirlas y poder asignarlas a tus candidatos.
                    </MDTypography>
                  </Alert>
                )}
                <Grid container spacing={3} alignItems="center">
                  <Grid item xs={12} md={6}>
                    <Autocomplete
                      options={availableLicenses}
                      value={selectedLicenseType}
                      onChange={(event, newValue) => setSelectedLicenseType(newValue || "")}
                      renderInput={(params) => <MDInput {...params} label="Seleccionar Tipo de Licencia" placeholder="Seleccionar licencia..." />}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <MDButton
                      variant="gradient"
                      color={(() => {
                        const filteredIds = filteredRows.map(row => row.original?.id_candidato).filter(Boolean);
                        const allSelected = filteredIds.length > 0 && filteredIds.every(id => selectedCandidates.includes(id));
                        return allSelected ? "warning" : "secondary";
                      })()}
                      fullWidth
                      onClick={handleSelectAll}
                    >
                      {(() => {
                        const filteredIds = filteredRows.map(row => row.original?.id_candidato).filter(Boolean);
                        const allSelected = filteredIds.length > 0 && filteredIds.every(id => selectedCandidates.includes(id));
                        return allSelected ? (
                          <><Icon>clear</Icon>&nbsp;QUITAR MULTI-SELECCIÓN</>
                        ) : (
                          <><Icon>check_box</Icon>&nbsp;SELECCIONAR TODOS</>
                        );
                      })()}
                    </MDButton>
                  </Grid>
                </Grid>
                
                {selectedCandidates.length > 0 && (
                  <MDBox mt={2}>
                    <MDTypography variant="body2" color="info">
                      {selectedCandidates.length} candidato(s) seleccionado(s)
                      {selectedLicenseType && ` - Licencia: ${selectedLicenseType}`}
                      {` - Licencias disponibles: ${licencias.licencias_disponibles || 0}`}
                    </MDTypography>
                  </MDBox>
                )}
              </MDBox>
            </Card>
          </Grid>

          {/* Tabla de Candidatos */}
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Lista de Candidatos ({totalItems} total{filteredRows.length !== allCandidates.length ? `, ${filteredRows.length} filtrados` : ""})
                  {searchTerm && (
                    <MDTypography variant="caption" color="white" display="block">
                      Filtrado por: &quot;{searchTerm}&quot;
                    </MDTypography>
                  )}
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ 
                    columns: tableData.columns, 
                    rows: paginatedRows 
                  }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                />
              </MDBox>
              <MDBox px={3} pt={2} pb={3} display="flex" justifyContent="flex-end">
                <MDButton
                  variant="gradient"
                  color="success"
                  onClick={handleAssignLicense}
                  disabled={loading || showLicenseWarning}
                >
                  {loading ? (
                    <>
                      <Icon>hourglass_empty</Icon>&nbsp; ENVIANDO...
                    </>
                  ) : (
                    <>
                      <Icon>assignment</Icon>&nbsp; ASIGNAR LICENCIA
                    </>
                  )}
                </MDButton>
              </MDBox>
              <MDBox pt={3}>
                <Pagination
                  itemsPerPage={ITEMS_PER_PAGE}
                  totalItems={totalItems}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      <MDSnackbar
        color={notification.color}
        icon={notification.color === "success" ? "check" : notification.color === "error" ? "warning" : "info"}
        title={notification.color === "success" ? "Éxito" : notification.color === "error" ? "Error" : "Información"}
        content={notification.message}
        dateTime={new Date().toLocaleTimeString()}
        open={notification.open}
        onClose={closeNotification}
        close={closeNotification}
        bgWhite
      />

      <MDModal
        open={showConfirmModal}
        title="Confirmar Asignación de Licencia"
        onClose={() => setShowConfirmModal(false)}
      >
        <MDBox p={3} display="flex" flexDirection="column" alignItems="center" textAlign="center">
          <Icon color="warning" fontSize="large" sx={{ mb: 2 }}>warning</Icon>
          <MDTypography variant="h6" mb={2}>
            {`¿Estás seguro de que quieres asignar la licencia "${selectedLicenseType}" a ${selectedCandidates.length} candidato(s) seleccionado(s)?`}
          </MDTypography>
          <MDTypography variant="body2" color="text" mb={3}>
            Se descontarán {selectedCandidates.length} licencia(s). 
            Licencias restantes: {licencias.licencias_disponibles - selectedCandidates.length}
          </MDTypography>
          <MDBox display="flex" justifyContent="center" gap={2} width="100%">
            <MDButton
              variant="gradient"
              color="secondary"
              onClick={() => setShowConfirmModal(false)}
              sx={{ width: "150px" }}
            >
              Cancelar
            </MDButton>
            <MDButton
              variant="gradient"
              color="success"
              onClick={confirmAssignment}
              disabled={loading}
              sx={{ width: "150px" }}
            >
              Confirmar
            </MDButton>
          </MDBox>
        </MDBox>
      </MDModal>

      <Footer />
    </DashboardLayout>
  );
}

export default AsignarLicencias;